import React, { useEffect } from "react";
import { useApplicationContext } from "../../components/applicationComponents/context/applicationContext";
import TransferRequestComponent from "../../components/applicationComponents/transferRequest/TransferRequestComponent";

export default function TransferRequestPage() {
  const { setHeaderText } = useApplicationContext();
  useEffect(() => {
    setHeaderText({
      value: "Edit Child Transfer",
      icon: "view-app-icon mr-3 mt-0",
    });
  }, []);
  return (
    <>
      <TransferRequestComponent disabled={false} showBack={true} showEdit={false} />
    </>
  );
}
